var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "kmModal",
      attrs: {
        id: "kmModal",
        title: _vm.modalAction && _vm.modalAction.Title,
        size: "md",
        "hide-footer": "",
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.show()
        },
        hide: function($event) {
          return _vm.hide()
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "b-row",
            [
              _c(
                "NextFormGroup",
                { attrs: { title: _vm.$t("insert.vehicles.oldKm") } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text", readonly: "" },
                    model: {
                      value: _vm.oldKm,
                      callback: function($$v) {
                        _vm.oldKm = $$v
                      },
                      expression: "oldKm"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "NextFormGroup",
                {
                  attrs: {
                    title: _vm.$t("insert.vehicles.newKm"),
                    error: _vm.$v.newKm
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.newKm,
                      callback: function($$v) {
                        _vm.newKm = $$v
                      },
                      expression: "newKm"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-row", { staticClass: "mt-3" }, [
            _c(
              "div",
              { staticClass: "w-100 text-right" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "danger", size: "sm" },
                    on: {
                      click: function($event) {
                        return _vm.closeModal()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("index.close")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: _vm.disabled
                    },
                    on: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("list.save")) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2776e0b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2776e0b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/KmModal.vue
// module id = null
// module chunks = 